import React from 'react';
import './EditCensorModal.css'; // Vi genbruger stilen herfra

const SupportModal = ({ onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{maxWidth: '400px', textAlign: 'center'}}>
        
        <div className="modal-header" style={{justifyContent: 'center', position: 'relative', borderBottom: 'none'}}>
          <h2 className="modal-title">Support</h2>
          <button className="close-btn" onClick={onClose} style={{position: 'absolute', right: '0', top: '-5px'}}>&times;</button>
        </div>

        <div style={{padding: '10px 0 20px 0'}}>
          <p style={{marginBottom: '20px', color: '#666', lineHeight: '1.5'}}>
            Har du spørgsmål til systemet, eller oplever du en fejl?<br/>
            Du er altid velkommen til at kontakte os.
          </p>
          
          <div style={{background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #eee'}}>
            <p style={{fontSize: '1.1rem', marginBottom: '15px', color: '#003366'}}>
              📧 <strong>support@nuub.dk</strong>
            </p>
            <p style={{fontSize: '1.1rem', margin: 0, color: '#003366'}}>
              📞 <strong>+45 43 45 43 44</strong>
            </p>
          </div>
        </div>

        <div className="modal-footer" style={{justifyContent: 'center', borderTop: 'none', marginTop: 0}}>
          <button className="btn-cancel" onClick={onClose} style={{width: '100%'}}>Luk</button>
        </div>

      </div>
    </div>
  );
};

export default SupportModal;